import { styled } from 'styled-components';

export const DropdownWrapper = styled.div`
  background-color: ${({ theme }) => theme.colours.canvas.secondary.main};
  transition: background-color ${({ theme }) => theme.animation.duration.fast}
    ${({ theme }) => theme.animation.easing.moving};
  width: fit-content;
  /* The wrapper follows the control it wraps: kitbag's Button and Dropdown both
     name borderRadius.primary. */
  border-radius: ${({ theme }) => theme.borderRadius.primary};
  display: inline-flex;
`;
